/**
 * What stands in the battle royale's houses (ADR-0120 amended), each kind its map character: a run of one (a table, a bench, a
 * shelf, hay, a sofa; a bed two cells down) is one piece. A tall thing stops shots and sight (cover: shelves, the stove,
 * barrels, crates); a low one stops feet only. Things may stand outside too (barrels on a dock, hay in a field).
 */
export const FURNITURE = [
  { key: 'table', char: 'n', tall: false },
  { key: 'bench', char: 'd', tall: false },
  { key: 'shelf', char: 'l', tall: true },
  { key: 'hay', char: 'v', tall: false },
  { key: 'sofa', char: 'a', tall: false },
  { key: 'bed', char: 'u', tall: false },
  { key: 'stove', char: 'k', tall: true },
  { key: 'barrel', char: 'q', tall: true },
  { key: 'crates', char: 'i', tall: true },
  { key: 'sacks', char: 's', tall: false },
  { key: 'plant', char: 'p', tall: false },
] as const;

export type FurnitureKey = (typeof FURNITURE)[number]['key'];

/** The kind (an index into `FURNITURE`) a map character stands for. */
export const FURNITURE_BY_CHAR: Readonly<Record<string, number>> = Object.fromEntries(
  FURNITURE.map((f, i) => [f.char, i]),
);
